
import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseMixin } from "@/mixins/baseMixin";
import { Validations } from "vuelidate-property-decorators";
import { requiredIf } from "vuelidate/lib/validators";
import Validation from "@/components/Validation.vue";
import axios from "axios";
import FileSaver from "file-saver";
import Loading from "@/components/Loading.vue";

@Component({
  components: { Loading, Validation },
  mixins: [BaseMixin]
})
export default class DownloadOrderFormPageButton extends Vue {
  public name: string = "DownloadOrderFormPageButton";

  @Prop()
  public pageId!: number;

  @Prop()
  public catalogId!: number;

  @Prop()
  public exhibitorId!: number;

  @Prop()
  public is_released!: boolean;

  protected step = 1;

  protected modalId = "download-order-form-page-modal";

  protected cbPrintSelf = false;

  protected cbPrintByPrinter = false;

  protected cbWithSkus = true;

  protected printByPrinterSelectedPriceId = 0;

  protected prices: any[] = [];

  protected get selectedPrice(): any {
    const selected = this.prices.find(
      p => p.id === this.printByPrinterSelectedPriceId
    );
    return selected;
  }

  protected get printByPrinterSheetCountLabel(): string {
    console.debug("selectedPrice", this.selectedPrice);
    return this.selectedPrice
      ? [
          this.selectedPrice.label + ":",
          Number(this.selectedPrice.price).toFixed(2),
          this.selectedPrice.currency,
          "x",
          this.selectedPrice.quantity
          // "=",
          // Number(this.selectedPrice.calculated_price).toFixed(2),
          // this.selectedPrice.currency
        ].join(" ")
      : "";
  }

  @Validations()
  protected validations() {
    return {
      printByPrinterSelectedPriceId: {
        required: requiredIf(function(this: DownloadOrderFormPageButton) {
          return this.cbPrintByPrinter;
        })
      }
    };
  }

  protected showModal() {
    this.$bvModal.show(this.modalId);
  }

  protected onCloseModal(modalId: string): void {
    this.reset();
    this.$bvModal.hide(modalId);
  }

  protected reset(): void {
    this.step = 1;
    this.cbPrintSelf = false;
    this.cbPrintByPrinter = false;
    this.cbWithSkus = true;
    this.printByPrinterSelectedPriceId = 0;
    this.$v.$reset();
  }

  protected onSend(): void {
    this.$v.$touch();
    if (this.cbPrintByPrinter && this.$v.$invalid) {
      return;
    }
    if (this.cbPrintByPrinter) {
      this.step = 2;
    } else {
      this.confirmOrder();
    }
  }

  protected confirmOrder(): void {
    this.step = 3;
    this.$crudService
      .create({
        resource: "order-form/generate-native",
        descriptionField: "",
        data: {
          catalog_id: this.catalogId,
          is_self_print: this.cbPrintSelf,
          is_print_by_printer: this.cbPrintByPrinter,
          is_with_skus: this.cbWithSkus,
          expovina_product_price_id: this.cbPrintByPrinter
            ? this.printByPrinterSelectedPriceId
            : null
        }
      })
      .then((response: any) => {
        console.debug("DownloadOrderForm Response 1", response.data);
        this.step = 4;
        if (this.cbPrintSelf && response?.data?.download_url) {
          this.downloadFile(response.data.download_url);
        }
      });
    console.debug(
      "on send click (DownloadOrderFormPageButton",
      this.cbPrintByPrinter,
      this.cbPrintSelf
    );
  }

  protected async downloadFile(url: string) {
    const fileResponse = await axios.get(url, {
      responseType: "blob"
    });

    FileSaver.saveAs(fileResponse.data, "Expovina_Bestellformular.pdf");
  }

  protected fetchPricesDropdownData(): void {
    this.$crudService
      .findAll({
        resource: "order-form/prices-data",
        descriptionField: ""
      })
      .then((response: any) => {
        console.debug("Foo", response.data);
        if (response.data) {
          this.prices = response.data;
          console.debug("foo2", this.prices);
        }
      });
  }

  protected fetchCalculatedPricesDropdownData(): void {
    this.$crudService
      .findAll({
        resource: [
          "order-form",
          "calculated-prices",
          this.catalogId,
          this.exhibitorId
        ].join("/"),
        descriptionField: ""
      })
      .then((response: any) => {
        console.debug("Foo", response.data);
        if (response.data) {
          this.prices = response.data;
          console.debug("foo2", this.prices);
        }
      });
  }

  created() {
    //this.fetchPricesDropdownData();
    this.fetchCalculatedPricesDropdownData();
  }
}
